
import ExecutionStateTransitionsRepository from '@src/repositories/ExecutionStateTransitionsRepository';

class ExecutionStateTransitionsService {
  constructor() {
    this.repository = new ExecutionStateTransitionsRepository();
  }

  /**
   * Get execution state transitions by ID
   * @param {string} organizationId - Organization ID
   * @param {string} divisionId - Division ID
   * @param {string} executionId - Execution ID
   * @returns {Promise<ExecutionStateTransitions|null>} ExecutionStateTransitions instance or null if not found
   */
  async getExecutionStateTransitions(organizationId, divisionId, executionId) {
    try {
      const transitions = await this.repository.get(organizationId, divisionId, executionId);
      return transitions;
    } catch (error) {
      throw new Error(`Service error getting execution state transitions: ${error.message}`);
    }
  }
}

export default ExecutionStateTransitionsService;
